import { useMutation } from '@tanstack/react-query';
import { downloadFile } from 'helpers/generic';
import { ProjectMetadataParameter } from 'store/data/projects/types';
import { FileType } from 'types';
import { buildExportFileName, gatherProjectMetadata } from './gatherProjectMetadata';

export const useExportProjectMetadataMutation = ({
	projectId,
	metadataDefinition
}: {
	projectId: string;
	metadataDefinition: ProjectMetadataParameter[] | null;
}) => {
	return useMutation({
		mutationFn: async () => {
			if (!projectId) {
				throw new Error('Cannot export project metadata: missing project id');
			}

			const metadata = await gatherProjectMetadata({ projectId, metadataDefinition });

			downloadFile(
				JSON.stringify(metadata, null, 2),
				buildExportFileName(metadata.ledidiProjectMetadataExport.projectName, projectId),
				FileType.Json
			);
		}
	});
};
